import { render, staticRenderFns } from "./CreditorsListImport.vue?vue&type=template&id=e0fa483c&scoped=true&"
import script from "./CreditorsListImport.vue?vue&type=script&lang=js&"
export * from "./CreditorsListImport.vue?vue&type=script&lang=js&"
import style0 from "./CreditorsListImport.vue?vue&type=style&index=0&id=e0fa483c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fa483c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VDataTable,VIcon,VTextField})
